import { FunctionComponent } from "react"
import Modal from "../shared/modalContainer"
import ModalHeader from "../shared/modalHeader"
import ModalFooter from "../shared/modalFooter"
import { TrexNavigator } from "../../classes/navigator/navigator"
import styles from "./organizationMembershipAccessUpdate.module.scss"
import { useNavigate } from "react-router-dom"

interface ConfirmationModalProps {
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
    targetSubjectName: string
    confirmAction: "managed" | "full"
}

const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({
    isOpen,
    onConfirm,
    onCancel,
    targetSubjectName,
    confirmAction,
}) => {
    const navigate = useNavigate()

    if (!isOpen) {
        return <></>
    }

    let title = ""
    let text: React.ReactNode = ""

    if (confirmAction === "managed") {
        title = `Are you sure you want to limit well access for ${targetSubjectName}?`
        text = (
            <>
                <b>Warning:</b> If this user is currently subscribed to
                notifications for any wells that are not included in their
                updated access, those wells will be automatically removed from
                their notification subscriptions.
            </>
        )
    } else {
        title = `Are you sure you want to update well access for ${targetSubjectName}?`
        text = "This will give them access to all wells."
    }

    return (
        <Modal>
            <ModalHeader
                title="Confirm Access Update"
                onCloseOverride={onCancel}
                trexNavigator={
                    new TrexNavigator(
                        {
                            navigateTo: -1,
                            locationKey: "",
                            pathName: "",
                        },
                        navigate
                    )
                }
            />
            <div className={styles.confirmationContainer}>
                <div className={styles.confirmationContent}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text}>{text}</div>
                </div>
            </div>
            <ModalFooter
                advanceText="Confirm"
                handleAdvanceClick={onConfirm}
                disableAdvance={false}
                handlePreviousClick={onCancel}
                previousText="Cancel"
                disablePrevious={false}
                previousButtonCondition="default"
            />
        </Modal>
    )
}

export default ConfirmationModal
